import store from '../store';
import { STOP_LOADING } from '../actions/types';
import { PAIDIT_API } from '../config';
import { pushAlert, resetState } from '../actions';

export default (error) => {
    process.env.NODE_ENV === 'development' && console.log('Paidit server request failed:', error);

    const { config } = error;
    const { apiConfig } = config;

    store.dispatch({ type: STOP_LOADING, payload: config.url.split(PAIDIT_API)[1] });

    let data = null;
    let message = 'Unchaught server error';
    let messageCode = null;

    if (error && error.response) {
        if (error.response.status === 401) {
            if (error.response.data && error.response.data.name === 'TokenExpiredError') {
                store.dispatch(resetState());
                return;
            }

            data = 'Unverified token';
        }
        else if (error.response.status === 423)
            data = 'disabled';
        else
            data = error.response.data;
    } else {
        data = error;
    }

    if (data) {
        if (data.message) {
            message = data.message;
            messageCode = data.messageCode || null;
        } else if (data.error) {
            if (data.error.message) {
                message = data.error.message;
            } else {
                message = data.error;
            }
        } else if (typeof data === 'string' || data instanceof String) {
            message = data;
        }

        if (apiConfig && apiConfig.alertError && data !== 'cartTimeout') {
            store.dispatch(pushAlert(apiConfig.alertError));
        }
    }

    return apiConfig && apiConfig.rejectOnError && Promise.reject(Object.assign(new Error(message), { messageCode }));
};